import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { useForm } from 'react-hook-form';

import { MagicLinkLoginData } from '@/api/magicLink/magicLink.types';
import Button from '@/components/controls/Button';
import {
  defaultInputStyle,
  defaultLabelStyle,
} from '@/components/controls/CustomEntityFormField.tsx';
import CustomInput from '@/components/controls/CustomInput';
import { MagicLinkSchema } from '@/components/zod/types';

type MagicLinkFormProps = {
  onSubmit: (data: MagicLinkLoginData) => void;
};

const MagicLinkForm: FC<MagicLinkFormProps> = ({ onSubmit }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<MagicLinkLoginData>({
    resolver: zodResolver(MagicLinkSchema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CustomInput
        name="email"
        placeholder="Enter Email"
        type="text"
        label="Email"
        hasIcon={false}
        control={control}
        error={errors.email}
        inputStyle={defaultInputStyle}
        labelStyle={defaultLabelStyle}
      />
      <div className="mt-6 text-sm text-center text-gray-900">
        We will send you a one-time login link
      </div>
      <Button
        buttonStyle="justify-center items-center px-6 py-2 mt-5 text-base font-semibold text-white whitespace-nowrap bg-honoursOrange rounded-xl max-md:px-5 w-full text-lg"
        text="Send"
        buttonType={{ type: 'submit' }}
        hasImage={false}
      />
    </form>
  );
};

export default MagicLinkForm;
